import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marca uma requisição como "background" (polling automático).
 *
 * Requisições background NÃO renovam o timer de inatividade no frontend e o
 * interceptor adiciona o header `X-Background-Request: true`, fazendo o
 * backend também não renovar a sessão (`last_activity`). Assim um usuário
 * ausente com tarefa pendente em polling ainda é deslogado por inatividade.
 */
export const BACKGROUND_REQUEST = new HttpContextToken<boolean>(() => false);

export function backgroundContext(): HttpContext {
  return new HttpContext().set(BACKGROUND_REQUEST, true);
}

/**
 * Suprime APENAS o reset local do timer de inatividade (`last_action`) no
 * envio, SEM mandar `X-Background-Request` — ou seja, o backend AINDA renova
 * a sessão. Usado pelo keepalive explícito ("Continuar conectado"), que só
 * deve resetar o estado local após o backend confirmar (204). Assim uma
 * falha de keepalive não mascara a expiração resetando o timer cedo demais.
 */
export const SUPPRESS_IDLE_RESET = new HttpContextToken<boolean>(() => false);

export function suppressIdleResetContext(): HttpContext {
  return new HttpContext().set(SUPPRESS_IDLE_RESET, true);
}
